module.exports = __webpack_public_path__ + "static/img/62993780.2d962169.png";